import { cn, focusRing } from "@simpro/ui";
import { CalendarPlus } from "lucide-react";
import { Link } from "react-router";
import { useShellStore } from "./shell.store";

/**
 * One button that always starts a booking, in the thumb zone on phones and tablets (design note S1).
 * It says "Book now" in words at every scroll position, because an unlabelled calendar icon was missed
 * once the page moved (owner request, 2026-10-29). It gives its place to a basket bar once something is
 * picked, to the action bar inside the flow (the layout leaves it out there), and to the home page's own
 * Book button while that is on screen, so it arrives as the hero's button scrolls away. Desktops have
 * Book now in the header instead.
 */
export function FloatingBook() {
  const basketOpen = useShellStore((state) => state.basketOpen);
  const inlineBook = useShellStore((state) => state.inlineBookVisible);

  if (basketOpen || inlineBook) return null;

  return (
    <nav
      aria-label="Quick booking"
      className="pointer-events-none fixed right-5 bottom-[calc(1.25rem+env(safe-area-inset-bottom))] z-30 lg:hidden"
    >
      <Link
        to="/book"
        viewTransition
        className={cn(
          "animate-arrive shadow-float pointer-events-auto inline-flex h-14 items-center gap-2.5 rounded-full bg-accent-500 pr-6 pl-5 text-[15px] font-semibold text-on-accent transition-transform duration-300 hover:scale-105 active:scale-95",
          focusRing,
        )}
      >
        <CalendarPlus className="size-5" strokeWidth={1.75} aria-hidden="true" />
        Book now
      </Link>
    </nav>
  );
}
